export const TOGGLE_FEED_VISIBILITY = 'TOGGLE_FEED_VISIBILITY';

export function toggleFeedVisibility(showFeed) {
  return {
    type: TOGGLE_FEED_VISIBILITY,
    payload: { showFeed }
  };
}
